import { FaqTypeIcon, FaqTypeButtonFlexBox } from './faq-styles'
import bookingCancelation from './assets/bookingCancelation.svg'
import bookingList from './assets/bookingList.svg'
import deskBooking from './assets/deskBooking.svg'
import settingAccount from './assets/settingAccount.svg'
import technicalSupport from './assets/technicalSupport.svg'
import FaqTypeButton from './faq-type-button'
import reporting from './assets/reporting.svg'
import calendar from './assets/calendar.svg'

export type FaqCategoryButtonsProps = {
  selected: number
  setSelected: (buttonNumber: number) => void
}

const buttonConfig = [
  {
    text: 'Getting Started',
    src: settingAccount,
    alt: 'Setting Account'
  },
  {
    text: 'Calendar',
    src: calendar,
    alt: 'Calendar'
  },
  { text: 'Desk Booking', src: deskBooking, alt: 'Desk Booking' },
  { text: 'My Booking List', src: bookingList, alt: 'My Booking List' },
  {
    text: 'Booking Cancelation',
    src: bookingCancelation,
    alt: 'Booking Cancelation'
  },
  {
    text: 'Reporting',
    src: reporting,
    alt: 'Reporting'
  },
  {
    text: 'Technical Support',
    src: technicalSupport,
    alt: 'Technical Support'
  }
]

const FaqCategoryButtons = ({ selected, setSelected }: FaqCategoryButtonsProps) => {
  return (
    <FaqTypeButtonFlexBox>
      {buttonConfig.map((button, index) => (
        <FaqTypeButton
          key={index}
          onClick={() => setSelected(index)}
          selected={index === selected}
          buttonText={button.text}
          buttonIcon={<FaqTypeIcon src={button.src} alt={button.alt} />}
        />
      ))}
    </FaqTypeButtonFlexBox>
  )
}

export default FaqCategoryButtons
